import { AxiosResponse } from 'axios';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const emailApi = {
  sendExternalInterestEmail: async (siteId: string, trialId: string): Promise<AxiosResponse<void>> => {
    return axios.post(`${TRIALS_API_ROOT}/v1/email/site/${siteId}/trial/${trialId}`);
  },
};
